import React, { useCallback, useEffect, useState } from 'react';
import { GoogleMap, Marker, DirectionsService, DirectionsRenderer } from '@react-google-maps/api';
import markerDot from './assets/marker-dot-red.png';
import markerDotGreen from './assets/marker-dot-green.png';
import DELIVERY_STATUS from '../../components/constants/deliveryStatus';

const containerStyle = {
  position: 'absolute',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',
};

const center = {
  lat: 58.6942,
  lng: 24.9077,
};

const MEMBO_WAREHOUSE_COORDINATES = {
  lat: 59.421957,
  lon: 24.798331,
};

const DEFAULT_MAP_ZOOM = 7.8;

const RoutesMap = ({
  routes,
  routePlan,
  deliveries,
  setActiveDelivery,
  activeDelivery,
  activeRouteWithColor,
  setActiveRouteWithColor,
}) => {
  const [map, setMap] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const [directions, setDirections] = useState(null);
  const [directionsService, setDirectionsService] = useState(null);

  const onLoad = useCallback(function callback(map) {
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

  useEffect(() => {
    setDirections([]);
  }, [routes]);

  useEffect(() => {
    if (activeRouteWithColor && directionsService) {
      setTimeout(() => {
        fetchDirectionsForRoutes(directionsService);
      }, 500);
    } else {
      setDirections(null);
      if (map) {
        map.panTo(center);
        map.setZoom(DEFAULT_MAP_ZOOM);
      }
    }
  }, [activeRouteWithColor]);

  useEffect(() => {
    if (!map) {
      return;
    }

    if (activeDelivery) {
      map.setZoom(15);
      map.panTo({ lat: Number(activeDelivery.coordinates.lat), lng: Number(activeDelivery.coordinates.lon) });
    } else {
      map.setZoom(DEFAULT_MAP_ZOOM);
      map.panTo(center);
    }
  }, [activeDelivery]);

  const fetchDirectionsForRoutes = (directionsService) => {
    if (!activeRouteWithColor) {
      return;
    }

    const wayPoints = activeRouteWithColor.route.deliveries.map((delivery) => ({
      location: { lat: Number(delivery.coordinates.lat), lng: Number(delivery.coordinates.lon) },
      stopover: true,
    }));

    const lastDelivery = activeRouteWithColor.route.deliveries[activeRouteWithColor.route.deliveries.length - 1];

    const getDirectionsForRoute = (route, callBack) => {
      directionsService.route(
        {
          origin: {
            lat: Number(
              route.startDepot?.coordinates.lat ||
                routePlan.startingAddress?.coordinates.lat ||
                MEMBO_WAREHOUSE_COORDINATES.lat
            ),
            lng: Number(
              route.startDepot?.coordinates.lon ||
                routePlan.startingAddress?.coordinates.lon ||
                MEMBO_WAREHOUSE_COORDINATES.lon
            ),
          },
          destination: { lat: Number(lastDelivery.coordinates.lat), lng: Number(lastDelivery.coordinates.lon) },
          waypoints: wayPoints,
          travelMode: 'DRIVING',
        },
        callBack
      );
    };

    getDirectionsForRoute(activeRouteWithColor.route, (response, status) => {
      if (status === 'OK') {
        setDirections([{ routeId: activeRouteWithColor.route.id, response, color: activeRouteWithColor.color }]);
      }
    });
  };

  const onMarkerClick = (delivery) => {
    const deliveryRoute = routes.find((route) => route.deliveries.some((d) => d.id === delivery.id));
    if (deliveryRoute) {
      setActiveRouteWithColor(deliveryRoute);
    } else {
      setActiveDelivery(delivery);
    }
  };

  return (
    <div className="routes-map">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={DEFAULT_MAP_ZOOM}
        onLoad={onLoad}
        onUnmount={onUnmount}
        options={{
          mapId: '4797b96dc63299d7',
        }}
      >
        <>
          {deliveries?.map((delivery) => {
            return (
              <Marker
                key={delivery.id}
                icon={delivery.status === DELIVERY_STATUS.finished.name ? markerDotGreen : markerDot}
                onLoad={onLoad}
                onClick={() => onMarkerClick(delivery)}
                label={
                  activeDelivery?.id === delivery.id ||
                  activeRouteWithColor?.route.deliveries.some((d) => d.id === delivery.id)
                    ? {
                        text: delivery.name,
                        color: '#000000',
                        fontSize: '14px',
                        fontWeight: '500',
                      }
                    : null
                }
                position={{
                  lat: Number(delivery.coordinates.lat),
                  lng: Number(delivery.coordinates.lon),
                }}
              />
            );
          })}

          <DirectionsService
            options={{
              origin: { lat: Number(MEMBO_WAREHOUSE_COORDINATES.lat), lng: Number(MEMBO_WAREHOUSE_COORDINATES.lon) },
              destination: {
                lat: Number(MEMBO_WAREHOUSE_COORDINATES.lat),
                lng: Number(MEMBO_WAREHOUSE_COORDINATES.lon),
              },
              travelMode: 'DRIVING',
            }}
            callback={() => {}}
            onLoad={(newDirectionsService) => {
              fetchDirectionsForRoutes(newDirectionsService);
              setDirectionsService(newDirectionsService);
            }}
          />

          {directions
            ? directions.map(({ response, routeId, color }) => (
                <DirectionsRenderer
                  key={routeId}
                  options={{
                    directions: response,
                    polylineOptions: {
                      strokeColor: color,
                    },
                    suppressMarkers: true,
                  }}
                />
              ))
            : ''}
        </>
      </GoogleMap>
    </div>
  );
};

RoutesMap.propTypes = {};

RoutesMap.defaultProps = {};

export default RoutesMap;
